import React from 'react';
import { Heart, Facebook, Twitter, Instagram, Youtube, MapPin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/a5c6u8x8_mmt%20logo.jpg" 
                alt="MMT Logo" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-green-400">MMT</h3>
                <p className="text-xs text-gray-400">Reg. No: {contactInfo.registration}</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Mass Movement For Transformation - An Ambedkarite Buddhist organization dedicated to the revival of Buddhism and social transformation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  About Babasaheb
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('vision').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Vision & Mission
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('team').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Governing Council
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('dhamma').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Buddha and His Dhamma
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('initiatives').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Our Initiatives
                </button>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get Involved</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('volunteer').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Volunteer
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('donate').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Donate
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Events
                </a>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
            <div className="space-y-3 mb-6">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-gray-400 flex-shrink-0 mt-1" />
                <p className="text-gray-400 text-sm">
                  {contactInfo.address}
                </p>
              </div>
              <p className="text-gray-400 text-sm">
                <span className="font-semibold text-white">Phone:</span><br />
                {contactInfo.phone}
              </p>
              <p className="text-gray-400 text-sm break-all">
                <span className="font-semibold text-white">Email:</span><br />
                {contactInfo.email}
              </p>
            </div>
            <div className="flex gap-3">
              <a href={contactInfo.socialMedia.facebook} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={contactInfo.socialMedia.twitter} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href={contactInfo.socialMedia.instagram} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href={contactInfo.socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Mass Movement For Transformation. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-2">
              Made with <Heart className="w-4 h-4 text-red-500 fill-current" /> for Prabuddha Bharath
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
